import React, { KeyboardEvent } from 'react';

import { TextInput } from '../text';
import { Button } from '@common/components/button';

const MAX_LENGTH_OPTION = 250;

export type TPollOption = {
  id: string;
  value: string;
};

type FormInputOptionsOptionOwnProps = {
  item: TPollOption;
  index: number;
  onAddNewOption: () => void;
  onChange: (index: number, option: TPollOption['value']) => void;
  onRemove: (idToRemove: string) => void;
};

const FormInputOptionsOption = ({
  item, index, onAddNewOption, onChange, onRemove,
}: FormInputOptionsOptionOwnProps) => {
  return (
    <div className="Form__Poll__Options__Option">
      <Button
        icon="delete"
        size="large"
        onClick={() => onRemove(item.id)}
      />
      <TextInput
        maxLength={MAX_LENGTH_OPTION}
        value={item.value}
        onChange={(e) => onChange(index, e.target.value)}
        onKeyPress={(e: KeyboardEvent<HTMLInputElement>) => {
          if (e.key === 'Enter') {
            onAddNewOption();
          }
        }}
      />
    </div>
  );
};

export default FormInputOptionsOption;
